import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const TeamMemberState = {
  members: [],
}

export const TeamMemberActions = {
  getTeamMembers: async ({ commit }, teamId) => {
    return axiosRequest.
      get(`/teams/${teamId}/members`).
      then(({ data }) => commit('setTeamMembers', data)).
      catch(handleError)
  },
}

export const TeamMemberGetters = {
  teamMembers: state => state.members || [],
}

export const TeamMemberMutations = {

  setTeamMembers: (state, members) => (state.members = members || []),
}
